import { ImageProps } from 'next/image';
import styles from './TimelineControls.module.scss';

import cx from 'classnames';
import { forwardRef } from 'react';

type Item = {
  label: string;
  value: string;
  image?: ImageProps;
};

export type TimelineControlsProps = {
  className?: string;
  items: Item[];
  activeIndex?: number;
  onChange: (item: Item, index: number) => void;
};

export const TimelineControls = forwardRef<
  HTMLDivElement,
  TimelineControlsProps
>(({ className, items, activeIndex, onChange }, ref) => {
  return (
    <div className={cx(styles.base, className)}>
      <div className={styles.wrapper} ref={ref}>
        {items.map((item, index) => (
          <button
            key={item.value}
            className={cx(
              styles.item,
              index === activeIndex && styles['item--active']
            )}
            onClick={() => onChange(item, index)}>
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
});
